<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header" style="background-color: #DBECDB;">
          <div class="row">
            <div class="col-md-6">
              <h5 class="card-title">Detalle de Registro - Ventanilla #</h5>
            </div>
            <div class="col-md-6 text-end">
              <BButton
                @click="$router.go(-1)"
                variant="secondary"
                class="me-2"
              >
                <i class="fa fa-arrow-left me-1"></i> Volver
              </BButton>
              <BButton
                @click="generatePDF"
                variant="danger"
                class="me-2"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
              <BButton
                @click="editRecord"
                variant="warning"
                v-if="hasPermission('ventanilla_edit')"
              >
                <i class="fa fa-edit me-1"></i> Editar
              </BButton>
            </div>
          </div>
        </div>
        
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-2">Cargando información del registro...</p>
          </div>
          
          <div v-else-if="ventanilla">
            <!-- Información principal -->
            <div class="row mb-4">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header bg-light">
                    <h6 class="mb-0">Información General</h6>
                  </div>
                  <div class="card-body">
                    <table class="table table-sm table-borderless">
                      <tr>
                        <td width="40%"><strong>Número de Registro:</strong></td>
                        <td>
                          <BBadge variant="primary" class="fs-6">
                            #{{ ventanilla.numero }}
                          </BBadge>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Área:</strong></td>
                        <td>
                          <i class="fa fa-building me-1 text-muted"></i>
                          {{ ventanilla.area.nombre_area }}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Estado:</strong></td>
                        <td>
                          <BBadge :variant="getBadgeVariant(ventanilla.estado)" class="fs-6">
                            {{ ventanilla.estado.toUpperCase() }}
                          </BBadge>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Fecha de Registro:</strong></td>
                        <td>
                          <i class="fa fa-calendar me-1 text-muted"></i>
                          {{ formatDateTime(ventanilla.fecha_registro) }}
                        </td>
                      </tr>
                      <tr v-if="ventanilla.fecha_edicion">
                        <td><strong>Última Edición:</strong></td>
                        <td>
                          <i class="fa fa-edit me-1 text-muted"></i>
                          {{ formatDateTime(ventanilla.fecha_edicion) }}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Registrado por:</strong></td>
                        <td>
                          <i class="fa fa-user me-1 text-muted"></i>
                          <span v-if="ventanilla.usuario_registro">
                            {{ ventanilla.usuario_registro.nombres }} 
                            {{ ventanilla.usuario_registro.paterno }}
                            {{ ventanilla.usuario_registro.materno }}
                          </span>
                          <span v-else class="text-muted">N/A</span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="card h-95">
                  <div class="card-header bg-light">
                    <h6 class="mb-0">Detalle de Entrada</h6>
                  </div>
                  <div class="card-body">
                    <div class="d-flex align-items-start">
                      <i class="fa fa-file-text me-2 mt-1 text-muted"></i>
                      <div>
                        <p class="mb-0" style="text-align: justify; ">
                          {{ ventanilla.detalle_entrada }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Resumen de items -->
            <div class="row mb-4">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header bg-light">
                    <h6 class="mb-0">Resumen de Items</h6>
                  </div>
                  <div class="card-body">
                    <div class="row text-center">
                      <div class="col-md-3">
                        <div class="border rounded p-3 bg-success bg-opacity-10">
                          <h4 class="text-success mb-1">{{ ventanilla.detalles.length }}</h4>
                          <small class="text-muted">Total de Items</small>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="border rounded p-3 bg-primary bg-opacity-10">
                          <h4 class="text-primary mb-1">{{ totalCantidad }}</h4>
                          <small class="text-muted">Total Cantidad</small>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="border rounded p-3 bg-info bg-opacity-10">
                          <h4 class="text-info mb-1">{{ seriesUnicas.length }}</h4>
                          <small class="text-muted">Series Diferentes</small>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="border rounded p-3 bg-warning bg-opacity-10">
                          <h4 class="text-warning mb-1">Bs. {{ formatNumber(totalVenta) }}</h4>
                          <small class="text-muted">Valor Total</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Items detallados -->
            <div class="card">
              <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h6 class="mb-0">Detalle de Items Registrados</h6>
                <BBadge variant="primary">
                  {{ ventanilla.detalles.length }} items
                </BBadge>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-sm table-striped table-hover">
                    <thead class="table-primary">
                      <tr>
                        <th width="5%">#</th>
                        <th width="25%">Item</th>
                        <th width="10%" class="text-center">Unidad</th>
                        <th width="8%" class="text-center">Cantidad</th>
                        <th width="8%" class="text-center">Serie</th>
                        <th width="12%" class="text-center">Origen</th>
                        <th width="12%" class="text-center">Rango Números</th>
                        <th width="10%" class="text-end">Costo Unitario</th>
                        <th width="10%" class="text-end">Subtotal</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(detalle, index) in ventanilla.detalles" :key="detalle.id">
                        <td class="fw-bold">{{ index + 1 }}</td>
                        <td>
                          <div>
                            <strong>{{ detalle.item.nombre_item }}</strong>
                            <br>
                            <small class="text-muted">Código: {{ detalle.item.codigo_item || 'N/A' }}</small>
                          </div>
                        </td>
                        <td class="text-center">
                          <BBadge variant="outline-secondary">
                            {{ detalle.item.unidad_medida }}
                          </BBadge>
                        </td>
                        <td class="text-center">
                          <span class="fw-bold">{{ detalle.cantidad }}</span>
                        </td>
                        <td class="text-center">
                          <BBadge variant="info" class="fs-6">
                            {{ detalle.serie }}
                          </BBadge>
                        </td>
                        <td class="text-center">
                          <BBadge :variant="detalle.origen === 'DDE' ? 'primary' : 'secondary'" class="fs-6">
                            {{ detalle.origen }}
                          </BBadge>
                        </td>
                        <td class="text-center">
                          <div class="d-flex align-items-center justify-content-center">
                            <span class="badge bg-light text-dark border">
                              {{ detalle.de_nro }} - {{ detalle.a_nro }}
                            </span>
                            <small class="text-muted ms-1">
                              ({{ (detalle.a_nro - detalle.de_nro) + 1 }})
                            </small>
                          </div>
                        </td>
                        <td class="text-end">
                          <span class="fw-bold">Bs. {{ formatNumber(detalle.costo_unitario) }}</span>
                        </td>
                        <td class="text-end">
                          <span class="fw-bold text-success">Bs. {{ formatNumber(detalle.cantidad * detalle.costo_unitario) }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot class="table-group-divider">
                      <tr>
                        <td colspan="8" class="text-end fw-bold fs-6">TOTAL GENERAL:</td>
                        <td class="text-end fw-bold fs-5 text-success">
                          Bs. {{ formatNumber(totalVenta) }}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <!-- Información adicional -->
                <div class="row mt-4">
                  <div class="col-md-6">
                    <div class="card border-0 bg-light">
                      <div class="card-body">
                        <h6 class="card-title">
                          <i class="fa fa-info-circle me-2 text-primary"></i>
                          Información de Series
                        </h6>
                        <div v-for="serie in seriesAgrupadas" :key="serie.nombre" class="mb-2">
                          <strong>Serie {{ serie.nombre }}:</strong> 
                          {{ serie.cantidad }} items, 
                          {{ serie.totalNumeros }} números
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card border-0 bg-light">
                      <div class="card-body">
                        <h6 class="card-title">
                          <i class="fa fa-chart-pie me-2 text-primary"></i>
                          Resumen por Origen
                        </h6>
                        <div v-for="origen in origenesAgrupados" :key="origen.nombre" class="mb-2">
                          <strong>{{ origen.nombre }}:</strong> 
                          {{ origen.cantidad }} items
                          ({{ origen.porcentaje }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Acciones -->
            <div class="row mt-4" v-if="hasPermission('ventanilla_edit')">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header bg-light">
                    <h6 class="mb-0">Acciones</h6>
                  </div>
                  <div class="card-body">
                    <div class="d-flex gap-2 flex-wrap">
                      <BButton
                        @click="editRecord"
                        variant="warning"
                        class="me-2"
                      >
                        <i class="fa fa-edit me-1"></i> Editar Registro
                      </BButton>
                      <BButton
                        @click="changeStatus('completado')"
                        variant="success"
                        class="me-2"
                        v-if="ventanilla.estado !== 'completado'"
                      >
                        <i class="fa fa-check me-1"></i> Marcar como Completado
                      </BButton>
                      <BButton
                        @click="changeStatus('cancelado')"
                        variant="danger"
                        class="me-2"
                        v-if="ventanilla.estado !== 'cancelado'"
                      >
                        <i class="fa fa-times me-1"></i> Cancelar Registro
                      </BButton>
                      <BButton
                        @click="changeStatus('pendiente')"
                        variant="info"
                        v-if="ventanilla.estado !== 'pendiente'"
                      >
                        <i class="fa fa-clock me-1"></i> Volver a Pendiente
                      </BButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div v-else class="text-center py-5">
            <div class="mb-4">
              <i class="fa fa-exclamation-triangle fa-3x text-warning"></i>
            </div>
            <h4 class="text-muted mb-3">Registro no encontrado</h4>
            <p class="text-muted mb-4">El registro que intentas visualizar no existe o no tienes permisos para acceder a él.</p>
            <BButton @click="$router.go(-1)" variant="primary" class="me-2">
              <i class="fa fa-arrow-left me-1"></i> Volver a la lista
            </BButton>
            <BButton @click="$router.push({ name: 'ventanilla' })" variant="outline-primary">
              <i class="fa fa-list me-1"></i> Ir al listado principal
            </BButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BButton, BBadge } from 'bootstrap-vue-3';
import { useAuthStore } from '@/stores/authStore';

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

// Datos
const ventanilla = ref(null);
const loading = ref(true);

// Computed properties
const totalVenta = computed(() => {
  if (!ventanilla.value?.detalles) return 0;
  return ventanilla.value.detalles.reduce((total, detalle) => {
    return total + (detalle.cantidad * detalle.costo_unitario);
  }, 0);
});

const totalCantidad = computed(() => {
  if (!ventanilla.value?.detalles) return 0;
  return ventanilla.value.detalles.reduce((total, detalle) => {
    return total + detalle.cantidad;
  }, 0);
});

const totalCostoUnitario = computed(() => {
  if (!ventanilla.value?.detalles) return 0;
  return ventanilla.value.detalles.reduce((total, detalle) => {
    return total + detalle.costo_unitario;
  }, 0);
});

const seriesUnicas = computed(() => {
  if (!ventanilla.value?.detalles) return [];
  const series = ventanilla.value.detalles.map(d => d.serie);
  return [...new Set(series)];
});

const seriesAgrupadas = computed(() => {
  if (!ventanilla.value?.detalles) return [];
  
  const agrupadas = {};
  ventanilla.value.detalles.forEach(detalle => {
    if (!agrupadas[detalle.serie]) {
      agrupadas[detalle.serie] = {
        nombre: detalle.serie,
        cantidad: 0,
        totalNumeros: 0
      };
    }
    agrupadas[detalle.serie].cantidad++;
    agrupadas[detalle.serie].totalNumeros += (detalle.a_nro - detalle.de_nro) + 1;
  });
  
  return Object.values(agrupadas);
});

const origenesAgrupados = computed(() => {
  if (!ventanilla.value?.detalles) return [];
  
  const agrupados = {};
  const totalItems = ventanilla.value.detalles.length;
  
  ventanilla.value.detalles.forEach(detalle => {
    if (!agrupados[detalle.origen]) {
      agrupados[detalle.origen] = {
        nombre: detalle.origen,
        cantidad: 0,
        porcentaje: 0
      };
    }
    agrupados[detalle.origen].cantidad++;
  });
  
  // Calcular porcentajes
  Object.values(agrupados).forEach(origen => {
    origen.porcentaje = ((origen.cantidad / totalItems) * 100).toFixed(1);
  });
  
  return Object.values(agrupados);
});

// Métodos
const fetchVentanilla = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/ventanilla/ver/${route.params.id}`);
    ventanilla.value = response.data.data;
  } catch (error) {
    console.error('Error al cargar el registro:', error);
    if (error.response?.status === 404) {
      Swal.fire('Error', 'El registro no fue encontrado', 'error');
    } else {
      Swal.fire('Error', 'No se pudo cargar el registro', 'error');
    }
  } finally {
    loading.value = false;
  }
};

const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  const options = { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  };
  return new Date(dateString).toLocaleDateString('es-BO', options);
};

const formatNumber = (number) => {
  return new Intl.NumberFormat('es-BO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number);
};

const getBadgeVariant = (estado) => {
  const variants = {
    pendiente: 'warning',
    completado: 'success',
    cancelado: 'danger'
  };
  return variants[estado] || 'secondary';
};

const generatePDF = async () => {
  try {
    const response = await axios.get(`/ventanilla/${route.params.id}/pdf`, {
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `ventanilla-${ventanilla.value.numero}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Error al generar PDF:', error);
    Swal.fire('Error', 'No se pudo generar el PDF', 'error');
  }
};

const editRecord = () => {
  router.push({ name: 'ventanilla-edit', params: { id: route.params.id } });
};

const changeStatus = async (nuevoEstado) => {
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: `¿Deseas cambiar el estado a "${nuevoEstado.toUpperCase()}"?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Sí, cambiar',
    cancelButtonText: 'Cancelar'
  });

  if (result.isConfirmed) {
    try {
      const response = await axios.put(`/ventanilla/${route.params.id}/cambiar-estado`, {
        estado: nuevoEstado
      });
      
      Swal.fire('Éxito', response.data.message, 'success');
      // Recargar los datos
      fetchVentanilla();
    } catch (error) {
      console.error('Error al cambiar estado:', error);
      Swal.fire('Error', error.response?.data?.message || 'Error al cambiar estado', 'error');
    }
  }
};

const hasPermission = (permission) => {
  return authStore.user?.permissions?.includes(permission);
};

// Inicialización
onMounted(() => {
  fetchVentanilla();
});
</script>

<style scoped>
.card-header {
  background-color: #DBECDB;
}

.table-borderless td {
  border: none !important;
}

.bg-opacity-10 {
  background-color: rgba(var(--bs-primary-rgb), 0.1) !important;
}

.table th {
  border-top: none;
  font-weight: 600;
  font-size: 0.95rem;
}

.table tfoot {
  border-top: 2px solid #dee2e6;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.btn {
  border-radius: 0.375rem;
}

.badge {
  font-size: 0.75em;
}

.text-justify {
  text-align: justify;
}

/* Estilos responsivos */
@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.875rem;
  }
  
  .btn {
    margin-bottom: 0.5rem;
  }
}
</style>